import AuthService from "../../AuthService";
const restaurant = {
  getRestaurant(page) {
    return AuthService.get("/service/restaurant?page=" + page);
  },
  showRestaurant(id) {
    return AuthService.get("/service/restaurant/" + id);
  },
  createRestaurant(data) {
    return AuthService.post("/service/restaurant", data);
  },
  updateRestaurant(id, data) {
    return AuthService.put("/service/restaurant/" + id, data);
  },
  deleteRestaurant(id) {
    return AuthService.delete("/service/restaurant/" + id);
  }
};
export default restaurant;
